<template>
  <!--begin::Product Listing-->
  <div class="part-template">
    <PageHeaderCount
      moduleType="part"
      :dataLoading="dataLoading"
      :statusList="statusList"
      :extraList="topExtraList"
      allkey="all_products"
      countkey="parts_status_count"
    ></PageHeaderCount>
    <v-col
      v-if="alphabets.length && false"
      md="12"
      class="alphabets-filter d-flex justify-center"
    >
      <div class="alphabets-scrollable">
        <v-btn
          :disabled="searching"
          depressed
          v-on:click="getLineItem(null, 'alphabet')"
          :class="{
            'cyan--text': null == alphabet,
            'cyan white--text': null != alphabet,
          }"
          class="custom-bold-button"
          small
          >All</v-btn
        >
        <v-btn
          :disabled="searching"
          depressed
          v-for="(row, index) in alphabets"
          v-on:click="getLineItem(row, 'alphabet')"
          :class="{
            'cyan--text': row == alphabet,
            'cyan white--text': row != alphabet,
          }"
          class="custom-bold-button"
          small
          :key="index"
          >{{ row }}
        </v-btn>
      </div>
    </v-col>
    <ListingTemplate
      :customClass="'parts-listing'"
      v-if="getPermission('parts:view')"
    >
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('parts:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                        depressed
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(item, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="productBulkAction(item)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              item.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                  depressed
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="pt-0">
                <v-layout class="w-100">
                  <v-flex class="mxw-177">
                    <h1 class="form-title d-flex margin-auto">
                      <!-- <pre>{{statusList}}</pre> -->
                      <v-select
                        :disabled="dataLoading"
                        :items="statusList"
                        v-model="status"
                        hide-details
                        item-color="cyan"
                        class="pt-0 mt-0 listing-status main-listing-status-filter"
                        item-text="text"
                        item-value="value"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-chip
                              :color="item.color"
                              :text-color="item.textcolor"
                            >
                              <template v-if="item.value == 'all'">{{
                                item.all_products
                              }}</template>
                              <template v-else>{{
                                item.parts_status_count
                              }}</template>
                            </v-chip>
                          </v-list-item-action>
                        </template>
                      </v-select>
                    </h1>
                  </v-flex>
                  <v-flex class="mxw-200">
                    <h1 class="form-title d-flex margin-auto">
                      <v-select
                        :disabled="dataLoading"
                        :items="categoryList"
                        v-model="category"
                        v-on:change="getRows()"
                        hide-details
                        item-color="cyan"
                        class="pt-0 mt-0 listing-status main-listing-status-filter"
                        item-text="text"
                        item-value="id"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content
                            v-on:click="setCategoryName(item.text)"
                          >
                            <v-list-item-title
                              v-text="item.text"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-chip
                              v-if="item.text != 'All Categories'"
                              color="cyan"
                              text-color="white"
                            >
                              <!-- <template v-if="!item.id">{{
                                item.all_products
                              }}</template> -->
                              <template>{{
                                item.quotation_status_count
                              }}</template>
                            </v-chip>
                          </v-list-item-action>
                        </template>
                      </v-select>
                    </h1>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('parts:create')">
                  <v-btn
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    :to="getDefaultRoute('part.create')"
                    depressed
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <template v-if="getPermission('parts:create') && false">
                  <v-btn
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button"
                    v-on:click="importDialog = true"
                    color="cyan white--text"
                    depressed
                  >
                    <v-icon dark left>mdi-database-import</v-icon> Import
                  </v-btn>
                </template>
                <v-btn
                  v-if="false"
                  :disabled="dataLoading"
                  class="mx-2 custom-bold-button"
                  v-on:click="exportQuotation"
                  color="cyan white--text"
                  depressed
                >
                  <v-icon dark left>mdi-database-export</v-icon> Export
                </v-btn>
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                  depressed
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      depressed
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    v-on:change="updateVisible()"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          v-on:change="updateVisible()"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          hide-details
                          class="pt-2 mt-0"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <PageTips v-if="false" module="parts"></PageTips>
              </v-flex>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Parts"
          :basicSearchFields="['name', 'barcode']"
          :allowedSearchFields="searchableArray"
        ></ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :style="{ 'max-width': cols.width }"
                      :class="{
                        'checkbox-width-limit': Number(cols.checkbox),
                        'pointer-events-none': lodash.isEmpty(rowData),
                      }"
                      :cols="Number(cols.checkbox)"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="rowData.length > 0">
                  <tr
                    class="arts-listing-row service-listing-row"
                    v-for="(data, index) in rowData"
                    :key="index"
                    link
                    :class="{ 'table-in-active-row': !data.activated }"
                  >
                    <template v-for="cols in customThead">
                      <td
                        v-if="cols.visible"
                        :key="cols.id"
                        :class="{
                          'simple-table-td': !cols.checkbox,
                          'checkbox-width-limit': cols.checkbox,
                        }"
                        :style="{ 'max-width': cols.width }"
                        v-on:click="
                          Number(cols.checkbox) == 0
                            ? rowClicked(data)
                            : 'javascript:void(0)'
                        "
                      >
                        <template
                          v-if="cols.checkbox && Number(cols.checkbox) == 1"
                        >
                          <v-checkbox
                            dense
                            v-model="selectedRows"
                            v-bind:value="data.id"
                            color="cyan"
                            class="hide-margin"
                            hide-details
                          ></v-checkbox>
                        </template>
                        <template v-else-if="cols.field == 'image'">
                          <v-avatar size="40">
                            <v-img
                              class="customer-image"
                              width="40"
                              height="40"
                              contain
                              :lazy-src="$defaultImage"
                              :src="$assetAPIURL(data.part_image)"
                            >
                            </v-img>
                          </v-avatar>
                        </template>
                        <template v-else-if="cols.field == 'barcode'">
                          <div class="d-flex align-center">
                            <Barcode :barcode="data.barcode"></Barcode>
                            <v-tooltip
                              top
                              v-if="data.infotech_sync_status == 1 || (data.infotech_id && data.infotech_sync_status != 3 && data.infotech_sync_status != 2)">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" x-small color="green lighten-5"
                                  class="green--text text--darken-3 font-weight-600 px-2 my-1 ml-2" label>
                                  <v-icon x-small left color="green darken-2">mdi-check-circle</v-icon>
                                  Info-Tech Synced
                                </v-chip>
                              </template>
                              <span>
                                <template v-if="data.infotech_synced_at">
                                  Last Synced: {{ formatDateTime(data.infotech_synced_at) }}
                                </template>
                                <template v-else>Last Synced</template>
                              </span>
                            </v-tooltip>
                            <v-tooltip top v-else-if="data.infotech_sync_status == 3">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" x-small color="orange lighten-5"
                                  class="orange--text text--darken-3 font-weight-600 px-2 my-1 ml-2" label>
                                  <v-icon x-small left color="orange darken-2"
                                    class="spin-infotech-icon">mdi-sync</v-icon>
                                  Under Sync
                                </v-chip>
                              </template>
                              <span>Syncing in background... Please refresh shortly</span>
                            </v-tooltip>
                            <v-tooltip top v-else-if="data.infotech_sync_status == 2">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" x-small color="red lighten-5"
                                  class="red--text text--darken-3 font-weight-600 px-2 my-1 ml-2" label>
                                  <v-icon x-small left color="red darken-2">mdi-alert-circle</v-icon>
                                  Sync Failed
                                </v-chip>
                              </template>
                              <span>{{ data.infotech_error || 'Info-Tech sync failed' }}</span>
                            </v-tooltip>
                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" x-small color="grey lighten-4"
                                  class="grey--text text--darken-2 font-weight-600 px-2 my-1 ml-2" label>
                                  <v-icon x-small left color="grey darken-1">mdi-cloud-off-outline</v-icon>
                                  Not Synced
                                </v-chip>
                              </template>
                              <span>Not Synced to Info-Tech</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'parts_name'">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Name: </b> {{ data.name || " - " }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Part Number: </b>
                            <template
                              v-if="
                                data?.product_prefix || data?.product_prefix_no
                              "
                            >
                              <span
                                v-if="data.product_prefix"
                                class="text-uppercase"
                                >{{ data?.product_prefix }}-</span
                              >{{ data?.product_prefix_no }}
                            </template>
                            <template v-else
                              ><em class="text-muted"
                                >No Part Number</em
                              ></template
                            >
                          </p>
                        </template>
                        <template v-else-if="cols.field == 'parts_info'">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Model: </b>
                            <template v-if="data?.brand">{{
                              data?.brand
                            }}</template>
                            <template v-else
                              ><em class="text-muted">No Model</em></template
                            >
                          </p>
                          <!-- <p class="m-0 custom-nowrap-ellipsis">
                            <b>Model: </b>
                            <template v-if="data?.model">{{
                              data?.model
                            }}</template>
                            <template v-else
                              ><em class="text-muted">No Model</em></template
                            >
                          </p> -->

                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Category: </b>
                            <template v-if="data.category">{{
                              data.category
                            }}</template>
                            <template v-else
                              ><em class="text-muted">No Category</em></template
                            >
                          </p>
                          <template v-if="false">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Reference #: </b>
                              <template v-if="data.reference">{{
                                data.reference
                              }}</template>
                              <template v-else
                                ><em class="text-muted"
                                  >No Reference #</em
                                ></template
                              >
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>SKU: </b>
                              <template v-if="data.sku">{{
                                data.sku
                              }}</template>
                              <template v-else
                                ><em class="text-muted">No SKU</em></template
                              >
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>UPC: </b>
                              <template v-if="data.upc">{{
                                data.upc
                              }}</template>
                              <template v-else
                                ><em class="text-muted">No UPC</em></template
                              >
                            </p>
                          </template>
                        </template>
                        <template v-else-if="cols.field == 'quantity'">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <span
                              class="font-weight-600"
                              style="font-size: 16px !important"
                            >
                              {{ data?.initial_stock }}</span
                            >
                            <span
                              class="font-weight-700"
                              style="font-size: 16px !important"
                            >
                              ({{ data?.unit }})</span
                            >
                          </p>
                        </template>
                        <template v-else-if="cols.field == 'dimension'">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Length: </b>
                            {{ data.length }} mm
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Width: </b>
                            {{ data.width }} mm
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Height: </b>
                            {{ data.height }} mm
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Weight: </b>
                            {{ data.weight }} kg
                          </p>
                        </template>
                        <template v-else-if="cols.field == 'commission_rate'">
                          {{ data.commission_rate }}
                        </template>
                        <template v-else-if="cols.field == 'price'">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Selling Price/Unit Price: </b>
                            <template v-if="data.sale_price">{{
                              $accountingJS.formatMoney(data.sale_price)
                            }}</template>
                            <template v-else><span> $ 0.00</span></template>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Discounted Price: </b>
                            <template v-if="data.discount_price">{{
                              $accountingJS.formatMoney(data.discount_price)
                            }}</template>
                            <template v-else><span>$ 0.00</span></template>
                          </p>
                        </template>

                        <template v-else-if="cols.field == 'supplier'">
                          <div class="d-flex align-items-center">
                            <template
                              v-if="getFilteredSupplers(data.suppliers).length"
                            >
                              <template
                                v-for="(row, index) in getFilteredSupplers(
                                  data.suppliers
                                )"
                              >
                                <v-tooltip
                                  top
                                  content-class="custom-top-tooltip"
                                  :key="'tooltip' + index"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-avatar
                                      v-bind="attrs"
                                      v-on="on"
                                      v-if="index < 2"
                                      color="blue lighten-4"
                                      class="ml-2"
                                      size="40"
                                      :style="`margin-left:${
                                        index > 0 ? '-12px' : ''
                                      };border:1px solid #0000002e !important`"
                                    >
                                      <template
                                        v-if="row && row.supplier_image"
                                      >
                                        <v-img
                                          :src="row.supplier_image"
                                        ></v-img>
                                      </template>
                                      <span
                                        v-else
                                        style="font-size: 14px"
                                        class=""
                                      >
                                        {{
                                          getTwoCharacter(
                                            row && row.supplier_name
                                          )
                                        }}
                                      </span>
                                    </v-avatar>
                                  </template>
                                  <span style="font-size: 11px">{{
                                    row.supplier_name
                                  }}</span>
                                </v-tooltip>
                                <v-chip
                                  v-if="index == 2"
                                  :key="'span' + index"
                                  x-small
                                  label
                                  color="blue darken-4 white--text"
                                  class="px-1"
                                >
                                  +{{ data.suppliers.length - 2 }} more
                                </v-chip>
                                <!-- @click.stop.prevent="routeToGo('suppliers', td.uuid)" -->
                                <!-- ({{ td.suppliers.length - 2 }} more)</span> -->
                              </template>
                            </template>
                            <template v-else>
                              <span>
                                <em class="text-muted">No supplier</em>
                              </span>
                            </template>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'quantity'">
                          <p v-if="false" class="m-0 custom-nowrap-ellipsis">
                            <v-tooltip left content-class="custom-left-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  class="tooltip-border-dashed"
                                  ><b>Initial: </b
                                  >{{
                                    $accountingJS.formatNumber(
                                      data.initial_stock
                                    )
                                  }}</span
                                >
                              </template>
                              <span
                                >The stock available for sale at<br />the
                                beginning of the accounting period.</span
                              >
                            </v-tooltip>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <v-tooltip left content-class="custom-left-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  class="tooltip-border-dashed"
                                  ><b>On Hand: </b
                                  >{{
                                    $accountingJS.formatNumber(
                                      data.stock_on_hand
                                    )
                                  }}</span
                                >
                              </template>
                              <span
                                >Current stock available for this item.</span
                              >
                            </v-tooltip>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <v-tooltip left content-class="custom-left-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  class="tooltip-border-dashed"
                                  ><b>Committed: </b
                                  >{{
                                    $accountingJS.formatNumber(
                                      data.committed_stock
                                    )
                                  }}</span
                                >
                              </template>
                              <span
                                >Stock that is committed to job(s) but not yet
                                invoiced.</span
                              >
                            </v-tooltip>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <v-tooltip left content-class="custom-left-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  class="tooltip-border-dashed"
                                  ><b>Available: </b
                                  >{{
                                    $accountingJS.formatNumber(
                                      data.available_stock
                                    )
                                  }}</span
                                >
                              </template>
                              <span
                                >Available for sale = Stock on Hand - Committed
                                Stock.</span
                              >
                            </v-tooltip>
                          </p>
                        </template>
                        <template v-else-if="cols.field == 'added_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.added_by)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.added_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              <template v-if="getDateCountAll(data.added_at)">{{
                                data.created_at
                              }}</template>
                              <template v-else>{{
                                formatDateTime(data.added_at)
                              }}</template>
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDate(data.added_at) }}
                              {{ formatTime(data.added_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else-if="cols.field == 'updated_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.updated_by)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.updated_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              {{ data.modified_at }}
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDateTime(data.updated_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else>
                          <div v-html="printRowData(cols, data)"></div>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-else-if="!dataLoading">
                  <td colspan="7" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no parts at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <Dialog :commonDialog="searchDialog">
          <template v-slot:title>Filter Part</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <template v-for="(field, index) in searchableArray">
                    <v-col md="6" :key="index" v-if="field == 'is_low_stock'">
                      <v-checkbox
                        class="mt-0 width-100"
                        color="cyan"
                        v-model.trim="listingSearch.is_low_stock"
                        @change="filterRows"
                      >
                        <template v-slot:label>
                          <label class="custom-form-label m-0 width-100"
                            >Low Stock</label
                          >
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col
                      md="6"
                      :key="index"
                      v-else-if="
                        field != 'dates' &&
                        field != 'purchase_cost' &&
                        field != 'selling_cost' &&
                        field != 'brand'
                      "
                    >
                      <label
                        class="font-weight-700 font-size-16 text-capitalize"
                        >{{ getFilterLabel(field, "Parts") }}</label
                      >
                      <v-text-field
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :label="getFilterLabel(field, 'Parts')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                    <v-col :key="index" md="6" v-if="field == 'brand'">
                      <label
                        class="font-weight-700 font-size-16 text-capitalize"
                        >Model</label
                      >
                      <v-text-field
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        label="Model"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
        <Dialog :commonDialog="syncAlertDialog" :dialogWidth="500">
          <template v-slot:title>{{ syncAlertTitle || "Info-Tech Sync" }}</template>
          <template v-slot:body>
            <div class="d-flex align-center py-2">
              <v-icon color="orange darken-2" large class="mr-3">mdi-information-outline</v-icon>
              <span class="font-size-16 font-weight-500">
                {{ syncAlertMessage }}
              </span>
            </div>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="syncAlertDialog = false"
            >
              OK
            </v-btn>
          </template>
        </Dialog>
        <ImportTemplate
          :dialog="importDialog"
          sample-url="public/import-samples/ProductImport.xlsx"
          api-url="productnew/import"
          title="Import Part"
          v-on:close="importDialog = false"
        ></ImportTemplate>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Product Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import ProductMixin from "@/core/lib/product/product.mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { DOWNLOAD, POST, PATCH } from "@/core/services/store/request.module";
import { saveAs } from "file-saver";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import moment from "moment-timezone";
import JwtService from "@/core/services/jwt.service";
import ImportTemplate from "@/view/pages/partials/Import-Template.vue";
import { ServiceFormEventBus } from "@/core/lib/service.form.lib";
import { filter } from "lodash";
export default {
  mixins: [CommonMixin, ListingMixin, ProductMixin],
  name: "part-list",
  data() {
    return {
      exportLoading: false,
      searching: false,
      pageModule: "part-listing",
      routeAPI: "parts",
      routeName: "part",
      routeDetailName: "part.detail",
      status: "all",
      file: "",
      importDialog: false,
      statusList: [],
      customThead: [],
      categoryList: [],
      CategoryCountList: [],
      allowedSearchFields: [
        "barcode",
        "company_name",
        "person_display_name",
        "unit_no",
        "street_1",
        "street_2",
        "zip_code",
        "city_name",
        "state_name",
        "country_name",
      ],
      alphabets: [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ],
      moreActions: [
        /*{
          title: "Import Product(s)",
          action: "import_items",
          divider: true,
          icon: "mdi-database-import",
        },
        {
          title: "Export Product(s)",
          action: "export_items",
          divider: false,
          icon: "mdi-database-export",
        },*/
        /*{
          title: "Export Current View",
          action: "export_current_view",
          divider: true,
          icon: "mdi-database-export",
        },*/
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      syncAlertDialog: false,
      syncAlertTitle: "Info-Tech Sync",
      syncAlertMessage: "",
      bulkActions: [
        {
          title: "Sync to Info-Tech",
          icon: "mdi-cloud-sync-outline",
          action: "sync_infotech",
        },
        {
          title: "Mark as Active",
          icon: "mdi-check-all",
          status: 1,
          action: "active",
        },
        {
          title: "Mark as In-Active",
          icon: "mdi-check-all",
          status: 0,
          action: "inactive",
        },
      ],
    };
  },
  components: {
    PageHeaderCount,
    ImportTemplate,
    draggable,
    PageTips,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
  },
  methods: {
    setCategoryName(name) {
      this.category_name = name;
    },
    getFilteredSupplers(suppliers) {
      const _supplier = filter(suppliers, (row) => row.id);
      return _supplier;
    },
    getTwoCharacter(word) {
      if (word) {
        return word.slice(0, 2).toUpperCase();
      }
      return "";
    },

    formatedateTime(param) {
      return moment(param).format("hh:mm A");
    },
    productBulkAction(item) {
      const _this = this;
      if (item && item.action === "sync_infotech") {
        const unsyncedRows = _this.rowData.filter(
          (r) =>
            _this.selectedRows.includes(r.id) &&
            (r.infotech_sync_status != 1 || !r.infotech_id)
        );
        const unsyncedIds = unsyncedRows.map((r) => r.id);

        // Only select unsynced parts on table
        _this.selectedRows = unsyncedIds;

        if (unsyncedIds.length === 0) {
          _this.syncAlertTitle = "Info-Tech Sync";
          _this.syncAlertMessage =
            "All selected parts are already synced with Info-Tech.";
          _this.syncAlertDialog = true;
          return;
        }

        // Immediately reflect status 3 (Under Sync) on UI
        for (let r of _this.rowData) {
          if (unsyncedIds.includes(r.id)) {
            r.infotech_sync_status = 3;
          }
        }

        _this.bulkSyncInfoTech(unsyncedIds);
        return;
      }

      const status = typeof item === "object" ? item.status : item;
      _this.$store
        .dispatch(PATCH, {
          url: "product",
          data: {
            status,
            products: _this.selectedRows,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.selectedRows = [];
          _this.getRows();
          _this.importDialog = false;
        });
    },
    bulkSyncInfoTech(itemIds) {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
        .dispatch(POST, {
          url: "infotech/sync/items/bulk",
          data: { items: itemIds },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
          let message = "Failed to sync parts to Info-Tech.";
          if (error && error.data && error.data.message) {
            message = error.data.message;
          }
          _this.syncAlertTitle = "Info-Tech Sync";
          _this.syncAlertMessage = message;
          _this.syncAlertDialog = true;
          _this.getRows();
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },
    exportQuotation() {
      //console.log(row,"rowhhh");
      //console.log(this.searchableArray,"searchableArray");

      let downloadURL = process.env.VUE_APP_API_URL + "products/export";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      //downloadURL.searchParams.append("search", this.queryParams.search);
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });

      this.lodash.map(this.listingSearch, function (row, index) {
        // console.log(index, "indexdd")

        if (index == "dates") {
          if (row && row[0]) {
            downloadURL.searchParams.append("dates[0]", row[0]);
          }
          if (row && row[1]) {
            downloadURL.searchParams.append("dates[1]", row[1]);
          }
        } else {
          downloadURL.searchParams.append(index, row);
        }

        //  downloadURL.searchParams.append(index, row);
      });
      window.open(downloadURL, "_blank");
    },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          _this.importDialog = true;
          break;
        case "export_items":
          _this.bulkProductExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("product");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    importRows() {
      // const _this = this;
      const file = this.$refs.file.files[0];
      if (!file) {
        alert("No file chosen");
        return;
      }
      const data = new FormData();
      data.append("excel", file);
      const _this = this;
      _this.$store
        .dispatch(POST, {
          url: "product/import",
          data: data,
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.selectedRows = [];
          _this.getRows();
          _this.importDialog = false;
        });
    },
    bulkProductExport() {
      const _this = this;
      let fileName = new Date();
      _this.exportLoading = true;
      _this.$store
        .dispatch(DOWNLOAD, {
          url: "products/export",
        })
        .then(({ data }) => {
          saveAs(data, "products-export-" + fileName.getTime() + ".xlsx");
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.exportLoading = false;
        });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Part",
      },
    ]);

    if (this.getPermission("parts:create") == false) {
      let index = this.lodash.findIndex(this.moreActions, {
        action: "import_items",
      });
      if (index >= 0) {
        this.moreActions.splice(index, 1);
      }
    }

    ServiceFormEventBus.$on("reload:staffdata", () => {
      this.getRows();
    });
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    // _this.defaultColDefs = [
    //   {
    //     headerName: "",
    //     field: "id",
    //     sort: null,
    //     visible: true,
    //     fixed: true,
    //     sortable: false,
    //     checkbox: true,
    //     order: 0,
    //     width: "50px",
    //   },
    //   {
    //     headerName: "Image",
    //     field: "image",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 1,
    //     width: "200px",
    //   },
    //   {
    //     headerName: "Model",
    //     field: "barcode",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 1,
    //     width: "200px",
    //   },
    //   {
    //     headerName: "Product's Info",
    //     field: "product_info",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 3,
    //     width: "300px",
    //   },
    //   /* {
    //     headerName: "Commission Rate (%)",
    //     field: "commission_rate",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 3,
    //     width: "300px",
    //   }, */
    //   {
    //     headerName: "Price",
    //     field: "price",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 3,
    //     width: "300px",
    //   },
    //   /* {
    //     headerName: "Stock",
    //     field: "quantity",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 3,
    //     width: "300px",
    //   }, */
    //   {
    //     headerName: "Created Time",
    //     child: "created_at",
    //     field: "added_at",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 8,
    //     width: "170px",
    //   },
    //   {
    //     headerName: "Last Modified Time",
    //     child: "modified_at",
    //     field: "updated_at",
    //     sort: null,
    //     visible: false,
    //     fixed: false,
    //     sortable: false,
    //     order: 9,
    //     width: "170px",
    //   },
    // ];

    // const defaultColDefs = _this.lodash.filter(_this.defaultColDefs, {
    //   visible: true,
    // });

    // _this.defaultColShow = defaultColDefs.map((col) => col.field);

    _this.status = _this.$route.query.status || _this.status;

    //_this.applyColState();

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
<style scoped>
.custom-listing-table tr.parts-listing-row:nth-child(odd) {
  background-color: #fff4de !important;
}
.custom-listing-table tr.parts-listing-row:hover {
  background-color: #eee !important;
}

@keyframes spin-infotech-anim {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spin-infotech-icon {
  animation: spin-infotech-anim 1.5s linear infinite;
}
</style>
